import { redirect } from "react-router";

export const oldPathRedirect = [
  //== 기존 PC방 URL Redirect (추후 제거 예정) ==//
  {
    // MY PC방 - 가입정보
    path: "/mypc/memInfo/myinfo",
    loader: () => redirect("/account/user"),
  },
  {
    // MY PC방 - IP 정보 - IP 접속 현황 & 과금 관리
    path: "/mypc/ipInfo/ipList",
    loader: () => redirect("/management/ip-setting"),
  },
  {
    // MY PC방 - IP 정보 - IP 등록 & 자리 설정
    path: "/mypc/ipInfo/ipAdd",
    loader: () => redirect("/management/ip-setting"),
  },
  {
    // MY PC방 - IP 정보 - 멀티 과금 설정
    path: "/mypc/ipInfo/ipMultiCharge",
    loader: () => redirect("/management/ip-setting"),
  },
  {
    // MY PC방 - IP 정보 - IP 변경 내역
    path: "/mypc/ipInfo/ipModification",
    loader: () => redirect("/management/ip-history"),
  },
  {
    // MY PC방 - 충전 내역
    path: "/product/gcoin/charge/chargeList",
    loader: () => redirect("/product/history/charge"),
  },
  {
    // MY PC방 - 이용 내역
    path: "/product/gcoin/charge/useList",
    loader: () => redirect("/product/history/usage"),
  },
  {
    // MY PC방 - 환불 신청
    path: "/mypc/refund/refund",
    loader: () => redirect("/product/refund/apply"),
  },
  {
    // MY PC방 - 환불 내역
    path: "/mypc/refund/list",
    loader: () => redirect("/product/refund/history"),
  },
  {
    // MY PC방 - 쿠폰
    path: "/mypc/refund/list",
    loader: () => redirect("/product/coupons"),
  },
  {
    // MY PC방 - 세금계산서
    path: "/mypc/tax/tax",
    loader: () => redirect("/product/tax"),
  },
  {
    // MY PC방 - 회원탈퇴
    path: "/mypc/tax/tax",
    loader: () => redirect("/account/user"),
  },
  {
    // 상품안내&결제 - G코인
    path: "/product/gcoin/index",
    loader: () => redirect("/product/charge/intro-and-charge"),
  },
  {
    // 상품안내&결제 - 자동결제
    path: "/product/gcoin/index",
    loader: () => redirect("/product/charge/intro-and-charge"),
  },
  {
    // 소식&이벤트 - 공지사항
    path: "/board/news/article",
    loader: () => redirect("/board/notice/list"),
  },
  {
    // 게임정보
    path: "/gameinfo/index",
    loader: () => redirect("/product/charge/aboutgame-and-advantage"),
  },
  {
    // 고객센터 - 고객센터 안내
    path: "/helpdesk/main",
    loader: () => redirect("/board/notice/list"),
  },
  {
    // 고객센터 - FAQ
    path: "/board/faq/main",
    loader: () => redirect("/board/faq/list"),
  },
  {
    // 고객센터 - 1:1문의
    path: "/board/question/contactus",
    loader: () => redirect("/helpdesk/contact"),
  },
  {
    // 고객센터 - 내 문의 내역
    path: "/board/question/article",
    loader: () => redirect("/helpdesk/contact/list"),
  },
  {
    // 고객센터 - 미납자 신고
    path: "/helpdesk/nonpaidreport/index",
    loader: () => redirect("/helpdesk/report"),
  },
  {
    // 고객센터 - 내 신고 내역
    path: "/helpdesk/nonpaidreport/nonpaidReportList",
    loader: () => redirect("/helpdesk/report"),
  },
  {
    // PC방 찾기
    path: "/company/v2/search",
    loader: () => redirect("/search/map"),
  },
  //== 기존 PC방 URL Redirect (추후 제거 예정) ==//
];
